import styled from 'styled-components';
import { Icon } from '../../atoms';
import React, { useState } from 'react';
import { StyledSpan } from '../../../styled';
import convertTimeStampToPersianFormat from '../../../utils/convertTimeStampToPersianFormat';
import { useDispatch } from 'react-redux';
import { setNotificationUnradCount } from '../../../store/actions/notification/NotificationActions';
import { SEEN_NOTIFICATION } from '../../../api-calls';
import { useTranslation } from "react-i18next";

interface OwnStyledProps {
  hasRadius?: boolean;
  hasSeparator?: boolean;
  showMessage?: boolean;
}
interface OwnProps extends OwnStyledProps {
  title?: string;
  date?: string;
  message?: string;
  seen?: boolean;
  id?: string;
}
const WrapperDivSadasd = styled.div<OwnStyledProps>`
  display: flex;
  // direction: rtl;
  cursor: pointer;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  /* min-height: 65px; */
  background: ${(p) => (theme: any) =>
    p.showMessage
      ? theme.theme.bgButton
      : window.innerWidth > 500
      ? theme.theme.bgColor1
      : theme.theme.bgColor2};
  margin-bottom: 8px;
  padding: 16px 8px;
  border-radius: ${(p) => (p.hasRadius ? "16px" : "unsent")};
  // border-bottom: ${(p) =>
    p.hasSeparator
      ? `1px solid ${(theme: any) => theme.theme.bgColor3}`
      : "none"};
  // &:last-child {
  //   border-bottom: none;
  // }
`;
const EllipseWrapperSasdasdS = styled.div`
  width: 32px;
  height: 32px;
  background: ${(theme: any) => theme.theme.Light4};
  border-radius: 50%;
`;
const GreenEllipseWrapperSasdasdS = styled.div<{ isRtl: boolean }>`
  position: absolute;
  bottom: 5px;
  // left: 3px;
  ${(props) => (props.isRtl ? 'left: 3px;' : 'right: 3px;')}
  width: 8px;
  height: 8px;
  background: ${(theme: any) => theme.theme.bgPrimary};
  border-radius: 50%;
`;
const TitleSpanSSsdas = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: ${(props) => (props.dir === "rtl" ? "right" : "left")};
  color: ${(theme: any) => theme.theme.white};
`;
const DateSpanSadaXx = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: inline;
  // direction: ltr;
  color: ${(theme: any) => theme.theme.Light3};
`;

const NotificationItem: React.FC<OwnProps> = ({
  hasRadius = true,
  hasSeparator = false,
  title = "",
  date = "",
  message = "",
  seen = false,
  id = "",
}) => {
  const { i18n } = useTranslation();
  const lng = i18n.language;
  const isRtl = i18n.dir() === "rtl";
  const [showMessage, setShowMessage] = useState(false);
  const [messageSeen, setMessageSeen] = useState(seen);
  // let formatedDate = convertTimeStampToPersianFormat(date);
  const formattedDate = isRtl
  ? convertTimeStampToPersianFormat(date)
  : (new Date(date).toISOString().split('T')[0]);

  const dispatch = useDispatch();
  const showMessageToUser = () => {
    if (!messageSeen) {
      makeNotifSeen();
    }
    setShowMessage((prev) => !prev);
  };
  const makeNotifSeen = async () => {
    SEEN_NOTIFICATION(id).then((res) => {
      dispatch(setNotificationUnradCount(res.data.data));
      setMessageSeen(true);
    });
  };
  return (
    <WrapperDivSadasd
      hasRadius={hasRadius}
      hasSeparator={hasSeparator}
      showMessage={showMessage}
      onClick={showMessageToUser}
    >
      <div style={{ display: 'flex' }}>
        <div style={{ position: 'relative' }}>
          <EllipseWrapperSasdasdS />
          {!messageSeen && <GreenEllipseWrapperSasdasdS isRtl={isRtl}/>}
        </div>
        <div style={{ marginInlineStart: "10px" }}>
          <TitleSpanSSsdas>{title}</TitleSpanSSsdas>
          <DateSpanSadaXx>{formattedDate}</DateSpanSadaXx>
          {showMessage && (
            <div
              style={{
                width: '80%',
                textAlign: isRtl ? 'right' : 'left',
                borderInlineStart: 'solid 1px #A4A6A8',
                paddingInlineStart: '8px',
              }}
            >
              <StyledSpan fontSize="12px" color="white">
                {message}
              </StyledSpan>
            </div>
          )}
        </div>
      </div>
      {showMessage ? (
        <div onClick={() => setShowMessage(false)}>
          <Icon name={'arrowBottomBlue'} width={'20px'} height={'20px'} />
        </div>
      ) : (
        <div onClick={showMessageToUser}>
          { lng === "fa" ?
            (<Icon onClick={showMessageToUser} name={'arrowRightBlue'} width={'20px'} height={'20px'} />)
            :
            (<Icon onClick={showMessageToUser} name={'arrowRightBlueEn'} width={'20px'} height={'20px'} />)
          }{' '}
        </div>
      )}
    </WrapperDivSadasd>
  );
};

export default NotificationItem;
